import axios from 'axios';
import EventBus from 'eventing-bus';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import { setAllMails, setAllInboxes, setAllCampaign, setSingleTask, setCampaignLogs, setAllAssistants, createScheduleEmail } from '.';

function* getAllCampaign() {
  const { error, response } = yield call(getCall, '/campaign/get');
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) yield put(setAllCampaign(response['data']['body']));
};

function* getAllInboxes() {
  try {
    const { error, response } = yield call(getCall, '/campaign/get-inboxes'); // Ensure this matches your backend route
    if (error) {
      EventBus.publish("error", error.response?.data?.message || "Error fetching inboxes");
    } else if (response) {
      yield put(setAllInboxes(response.data.data)); // Ensure correct structure
    }
  } catch (error) {
    console.error("Saga error fetching inboxes:", error);
  }
}
function* getAllMails(action) {
  try {
    const { email } = action.payload; // Get email from action

    if (!email) {
      EventBus.publish("error", "Email is required to fetch mails");
      return;
    }

    const { error, response } = yield call(getCall, `/campaign/get-mails?email=${email}`); // Send email as query param

    if (error) {
      EventBus.publish("error", error.response?.data?.message || "Error fetching Mails");
    } else if (response) {
      yield put(setAllMails(response.data.data)); // Update Redux store
    }
  } catch (error) {
    console.error("Saga error fetching emails:", error);
  }
}

function* getAllEmailCampaign() {
  const { error, response } = yield call(getCall, '/campaign/get-ecampaign');
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) yield put(setAllCampaign(response['data']['body']));
};

function* getSingleTask({ payload }) {
  const { error, response } = yield call(getCall, `/campaign/${payload}`);
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) yield put(setSingleTask(response['data']['body']));
};



function* createTask({ payload }) {
  const { successCallback, failCallback, formData } = payload;
  const { error, response } = yield call(postCall, { path: `/campaign/create-campaign`, payload: formData });
  if (error) {
    failCallback();
    EventBus.publish("error", error['response']['data']['message']) || error['message'] || 'Something went Wrong'
  } else if (response) {
    successCallback();
    EventBus.publish("success", response['data']['message']);
    yield put({ type: 'ADD_CAMPAIGN', payload: response.data.body });
  }
};
function* registerGAccounts({ payload }) {
  const { successCallback, failCallback, formData } = payload;
  const { error, response } = yield call(postCall, { path: `/campaign/oauth/callback`, payload: formData });
  if (error) {
    failCallback();
    const errorMessage = error?.response?.data?.error || error?.response?.data?.message || "Something went wrong";
    EventBus.publish("error", errorMessage);    // EventBus.publish("error", error['response']['data']['message']) || response.error|| 'Something went Wrong'
  } else if (response) {
    successCallback();
    EventBus.publish("success", response?.data?.message || "Account Registered Successfully");
    yield put({ type: 'ADD_REGISTER_ACCOUNT', payload: response.data.body });
  }
};
function* replyToUserEmail({ payload }) {
  const { successCallback, failCallback, formData } = payload;
  const { error, response } = yield call(postCall, { path: `/campaign/reply`, payload: formData });
  if (error) {
    failCallback();
    const errorMessage = error?.response?.data?.error || error?.response?.data?.message || "Something went wrong";
    EventBus.publish("error", errorMessage);    // EventBus.publish("error", error['response']['data']['message']) || response.error|| 'Something went Wrong'
  } else if (response) {
    successCallback();
    EventBus.publish("success", response?.data?.message || "Reply Sent Successfully");
    yield put({ type: 'SEND_REPLY', payload: response.data.body });
  }
};
function* registerAppPassAccounts({ payload }) {
  const { successCallback, failCallback, formData } = payload;
  const { error, response } = yield call(postCall, { path: `/campaign/register/account`, payload: formData });
  if (error) {
    failCallback();
    const errorMessage = error?.response?.data?.error || error?.response?.data?.message || "Something went wrong";
    EventBus.publish("error", errorMessage);    // EventBus.publish("error", error['response']['data']['message']) || response.error|| 'Something went Wrong'
  } else if (response) {
    successCallback();
    EventBus.publish("success", response?.data?.message || "Account Registered Successfully");
    yield put({ type: 'ADD_REGISTER_APP_ACCOUNT', payload: response.data.body });
  }
};
function* createEmailTask({ payload }) {
  const { successCallback, failCallback, formData } = payload;
  const { error, response } = yield call(postCall, { path: `/campaign/create-ecampaign`, payload: formData });
  if (error) {
    failCallback();
    EventBus.publish("error", error['response']['data']['message']) || error['message'] || 'Something went Wrong'
  } else if (response) {
    successCallback();
    EventBus.publish("success", response['data']['message']);
    yield put({ type: 'ADD_CAMPAIGN', payload: response.data.body });
  }
};


function* updateTask({ payload }) {
  const { successCallback, failCallback, formData, id } = payload;
  const { error, response } = yield call(putCall, { path: `/campaign/update-campaign/${id}`, payload: formData });
  if (error) {
    failCallback();
    EventBus.publish("error", error['response']['data']['message']);
  } else if (response) {
    console.log("response.data", response.data)
    successCallback();
    EventBus.publish("success", response['data']['message']);
    yield put({ type: 'UPDATE_CAMPAIGN_STATE', payload: response.data.body });
  }
};

function* scheduleEmail({ payload }) {
  const { successCallback, failCallback, formData, campaignId } = payload;
  const { error, response } = yield call(postCall, { path: `/campaign/schedule-email/${campaignId}`, payload: formData });
  if (error) {
    failCallback();
    EventBus.publish("error", error['response']['data']['message']) || error['message'] || 'Something went Wrong'
  } else if (response) {
    successCallback();
    EventBus.publish("success", response['data']['message']);
    // yield put({ createScheduleEmail, payload: response.data.body });
    yield put({ type: 'SET_EMAIL_SCHEDULE', payload: response.data.body });

  }
};

function* sendcontactsToSES({ payload }) {
  const { contactsData, campaignId } = payload;
  const { error, response } = yield call(postCall, {
    path: `/campaign/send-email`,
    payload: { contacts: contactsData, campaignId }
  });

  if (error) {
    EventBus.publish("error", error['response']['data']['message']);
  } else if (response) {
    EventBus.publish("success", response['data']['message']);
  }
}

function* updateStatus({ payload }) {
  const { error, response } = yield call(putCall, { path: `/campaign/status/${payload['id']}`, payload });
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) {
    EventBus.publish("success", response['data']['message']);
    yield put({ type: 'GET_ALL_CAMPAIGNS' });
  }
};

function* editTask({ payload, id }) {
  const { error, response } = yield call(putCall, { path: `/updateTask/${id}`, payload });
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) {
    EventBus.publish("success", response['data']['message']);
    yield put({ type: 'GET_SINGLE_CAMPAIGN', payload: id });
  }
};

function* getCampaignLogs({ payload }) {
  const { error, response } = yield call(getCall, `/campaign/campaignLogs/${payload}`);
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) yield put(setCampaignLogs(response['data']['body']));
};

function* deleteSingleCampaign({ payload }) {
  const { error, response } = yield call(deleteCall, `/campaign/delete/${payload}`);
  if (error) EventBus.publish("error", error['response']['data']['message']);
  else if (response) {
    EventBus.publish("success", response['data']['message']);
    yield put({ type: 'GET_ALL_CAMPAIGNS' });
  }
};


function* actionWatcher() {

  yield takeEvery('EDIT_CAMPAIGN', editTask);
  yield takeEvery('UPDATE_CAMPAIGN', updateTask);
  yield takeEvery('UPDATE_STATUS', updateStatus);
  yield takeEvery('CREATE_CAMPAIGN', createTask);
  yield takeEvery('CREATE_ACCOUNT', registerGAccounts);
  yield takeEvery('SEND_USER_EMAIL', replyToUserEmail);
  yield takeEvery('CREATE_APP_PASSWORD_ACCOUNT', registerAppPassAccounts);
  yield takeEvery('CREATE_EMAIL_CAMPAIGN', createEmailTask);
  yield takeEvery('GET_ALL_CAMPAIGNS', getAllCampaign);
  yield takeEvery('GET_ALL_EMAIL_CAMPAIGNS', getAllEmailCampaign);
  yield takeEvery('GET_SINGLE_CAMPAIGN', getSingleTask);
  yield takeEvery('GET_CAMPAIGN_LOGS', getCampaignLogs);
  yield takeEvery('DELETE_SINGLE_CAMPAIGN', deleteSingleCampaign);
  yield takeEvery('SET_EMAIL_SCHEDULE', scheduleEmail);
  yield takeEvery('SEND_EMAIL_TO_AWS_SES', sendcontactsToSES);
  yield takeEvery('GET_ALL_INBOXES', getAllInboxes);
  yield takeEvery('GET_ALL_MAILS', getAllMails);


}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}

function postCall({ path, payload }) {
  return axios
    .post(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}
// function postCall({ path, payload }) {
//   console.log("📡 Sending API Request:", path, payload); // Debugging log
//   return axios
//     .post(path, payload)
//     .then(response => {
//       console.log("✅ API Response:", response.data);
//       return { response };
//     })
//     .catch(error => {
//       console.error("❌ API Error:", error.message);
//       return { error };
//     });
// }


function getCall(path) {
  return axios
    .get(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}

function deleteCall(path) {
  return axios
    .delete(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}

function putCall({ path, payload }) {
  return axios
    .put(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}


function patchCall({ path, payload }) {
  return axios
    .patch(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}
